export { default } from './ProfileCardBig';
